export default class api {
  static apiConfig = {
    //baseUrl: 'http://8.129.173.32:8019/api',

    // 测试服
    // baseUrl:'http://apitest.haiouchat.com/api/',
    // 正式服
     baseUrl: 'https://api.haiouchat.com/api/',
     authUrl:'https://www.haiouchat.com/getURL',
    // 通过密码登陆
    uploadUrl: '/sysUser/login',
    login: '/sysUser/login',

    getDynamic: '/dynamic',


    androidOneUrl:"https://www.haiouchat.com/app/haiou.apk",

    androidTwoUrl:"https://www.haiouchat.com/app/haiou_bd.apk",

    androidOne:"haiou.apk",

    androidTwo:"haiou_bd.apk",


    iosUrl:"https://apps.apple.com/cn/app/%E6%B5%B7%E9%B8%A5-%E5%AE%89%E5%85%A8%E5%8A%A0%E5%AF%86%E8%81%8A%E5%A4%A9%E4%BA%A4%E5%8F%8B%E8%BD%AF%E4%BB%B6/id1584062834",

    haiouWeb:"https://web.haiouchat.com/",

    haiouKc:"https://www.haioukc.com/",

    windowsUrl:"https://www.haiouchat.com/app/haiou-pc.exe",
    
    windows:"haiou-pc.exe",


  };
}



// WEBPACK FOOTER //
// ./src/api/api.js